var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.WidgetBaseComponent, {
    directives: [
      {
        name: "resize",
        rawName: "v-resize",
        value: _setup.checkTruncation,
        expression: "checkTruncation",
      },
    ],
    ref: "widget",
    staticClass: "next-events-widget",
    attrs: { loadedData: _setup.allDataLoaded && !_setup.showSpinner },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "header-bar" },
              [
                _c("h2", [
                  _vm._v(
                    _vm._s(_setup.expedientGlobalVisionAppointments.title)
                  ),
                ]),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      bottom: "",
                      left: "",
                      "nudge-bottom": "24",
                      "content-class": "navigation-context-menu",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _setup.userHasPermissionToSaveAtLeastOneActionType
                              ? _c(
                                  "button",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        class: [
                                          _setup.icons.addButton,
                                          "add-button",
                                        ],
                                      },
                                      "button",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "v-list",
                      { staticClass: "list" },
                      _vm._l(_setup.contextMenuItems, function (item, index) {
                        return _c(
                          "v-list-item",
                          {
                            key: index,
                            staticClass: "list-item",
                            on: {
                              click: function ($event) {
                                return _setup.onContextMenuItemClicked(
                                  item.actionType
                                )
                              },
                            },
                          },
                          [
                            _c("span", { class: item.iconCss }),
                            _c("span", [_vm._v(_vm._s(item.text))]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _setup.expedientGlobalVisionAppointments.body.length > 0
              ? _c(
                  "section",
                  { staticClass: "events-container" },
                  _vm._l(
                    _setup.expedientGlobalVisionAppointments.body,
                    function (event, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "event",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _setup.goToEvent(event)
                            },
                          },
                        },
                        [
                          _c("span", {
                            class: [
                              _setup.checkActionIcon(event.idActionType),
                              "lf-icon__md",
                              "event-icon",
                            ],
                          }),
                          _c(
                            "div",
                            { staticClass: "event-info-container" },
                            [
                              _setup.isTruncatedItems[index]
                                ? _c(_setup.LexonTooltipComponent, {
                                    attrs: {
                                      message: event.subject,
                                      position: "top",
                                      isWidthAuto: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator-element",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  ref: (el) =>
                                                    _setup.setRef(el, index),
                                                  refInFor: true,
                                                  staticClass: "event-subject",
                                                },
                                                [_vm._v(_vm._s(event.subject))]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _c(
                                    "span",
                                    {
                                      ref: (el) => _setup.setRef(el, index),
                                      refInFor: true,
                                      staticClass: "event-subject",
                                    },
                                    [_vm._v(_vm._s(event.subject))]
                                  ),
                              _c("div", { staticClass: "event-info" }, [
                                _c("div", { staticClass: "data" }, [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v(_vm._s(_setup.text.date)),
                                  ]),
                                  _c("span", [_vm._v(_vm._s(event.startDate))]),
                                ]),
                                _c("div", { staticClass: "data" }, [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v(_vm._s(_setup.text.hour)),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        `${event.hourStart}h - ${event.hourEnd}h`
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "data" }, [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v(_vm._s(_setup.text.duration)),
                                  ]),
                                  _c("span", [
                                    _vm._v(_vm._s(event.duration || "-")),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ]
                      )
                    }
                  ),
                  0
                )
              : _c("div", { staticClass: "no-events-container" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c("span", {
                      class: [
                        _setup.icons.archiveEmpty,
                        "explanation-icon",
                        "lf-icon__xl",
                      ],
                    }),
                    _c("div", { staticClass: "explanation-container" }, [
                      _c("span", { staticClass: "explanation-title" }, [
                        _vm._v(_vm._s(_setup.text.noEvents)),
                      ]),
                      _c("p", { staticClass: "explanation" }, [
                        _vm._v(_vm._s(_setup.text.explanation)),
                      ]),
                    ]),
                  ]),
                ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }